/**
 * Configuración compartida de navegación (sidebar + command palette).
 * Extraído de Layout.jsx para evitar duplicación entre la barra lateral
 * y el modal Cmd+K.
 */
import {
  LayoutDashboard, Users as UsersIcon, UserCheck, Truck,
  FileText, ClipboardList, Warehouse as WarehouseIcon,
  BookMarked, Pill, Boxes, BriefcaseBusiness,
  ShoppingCart, Calculator, ArrowRightLeft, AlertCircle, UsersRound,
  LineChart, Receipt, FileBarChart2, FileMinus2, FileBadge2, FileCheck2, FileSpreadsheet, ShieldCheck,
  Thermometer, Percent, Target, FileClock, PackageCheck, Undo2, Building2, ArrowDownCircle, Settings2, Mail, BookOpen, ListTodo, TrendingDown, GitCompare, Wallet, Activity,
  Briefcase, Database, ShoppingBag, ScrollText, Banknote, Cog, Home, Archive, Hash, Package, Search,
  MessageCircle,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    key: "mi_espacio",
    label: "Mi espacio",
    icon: Home,
    alwaysOpen: true,
    items: [
      { to: "/", icon: LayoutDashboard, label: "Panel", exact: true, keywords: "dashboard inicio" },
      { to: "/tareas", icon: ListTodo, label: "Tareas y calendario", keywords: "agenda pendientes" },
      { to: "/mi-cartera", icon: TrendingDown, label: "Mi cartera", keywords: "clientes vendedor" },
      { to: "/liquidaciones-viaticos", icon: Receipt, label: "Mis viáticos", keywords: "gastos reembolso liquidacion" },
      { to: "/seguridad", icon: ShieldCheck, label: "Mi seguridad 2FA", keywords: "autenticacion password" },
    ],
  },
  {
    key: "ventas",
    label: "Ventas",
    icon: ShoppingBag,
    items: [
      { to: "/cotizaciones", icon: FileText, label: "Cotizaciones", module: "ventas", submodule: "cotizaciones", keywords: "proforma oferta" },
      { to: "/pedidos", icon: ClipboardList, label: "Notas de pedido", module: "ventas", submodule: "pedidos", keywords: "np orden venta" },
      { to: "/ventas/backorder", icon: Package, label: "Pendientes por stock", module: "ventas", submodule: "pedidos", keywords: "backorder faltantes espera complementaria" },
      { to: "/avisos-stock", icon: MessageCircle, label: "Avisos de stock (WhatsApp)", module: "ventas", keywords: "whatsapp aviso llego producto reposicion stock vendedores" },
      { to: "/cartas", icon: FileBadge2, label: "Cartas canje/garantía", module: "ventas" },
      { to: "/entregas", icon: PackageCheck, label: "Entregas y devoluciones", module: "ventas", keywords: "despacho devolucion" },
      { to: "/reporte-diario", icon: BriefcaseBusiness, label: "Reporte diario", module: "ventas", keywords: "actividad vendedor" },
      { to: "/rotacion-comercial", icon: Target, label: "Rotación comercial", module: "ventas", keywords: "ranking productos" },
    ],
  },
  {
    key: "compras",
    label: "Compras",
    icon: ShoppingCart,
    items: [
      { to: "/compras", icon: ShoppingCart, label: "Facturas de compra", module: "compras", keywords: "fc proveedor" },
      { to: "/compras/importar-sri", icon: FileSpreadsheet, label: "Importar facturas SRI", module: "compras", keywords: "sri recibidos xml descarga automatica clave acceso" },
      { to: "/solicitudes-compra", icon: ListTodo, label: "Solicitudes de compra", module: "gerencia", keywords: "requisicion pedido interno" },
      { to: "/comparador-costos", icon: GitCompare, label: "Comparador de costos", module: "compras" },
      { to: "/devoluciones-proveedor", icon: Undo2, label: "Devoluciones a proveedor", module: "bodega" },
      { to: "/notas-credito-proveedor", icon: FileMinus2, label: "NC Proveedor", module: "contabilidad", submodule: "nc_proveedor", keywords: "nota credito" },
    ],
  },
  {
    key: "inventario",
    label: "Inventario",
    icon: WarehouseIcon,
    items: [
      { to: "/bodega", icon: WarehouseIcon, label: "Stock y lotes", module: "bodega", submodule: "lotes", keywords: "caducidad fefo" },
      { to: "/despacho", icon: Boxes, label: "Despacho de pedidos", module: "bodega", submodule: "despacho", keywords: "armar pedidos cartones bultos guia remision bodega" },
      { to: "/movimientos", icon: ArrowRightLeft, label: "Movimientos", module: "bodega", submodule: "transferencias", keywords: "transferencia ajuste" },
      { to: "/bodega-ops", icon: Thermometer, label: "BPA · Temp/Limpieza", module: "bodega", keywords: "buenas practicas temperatura" },
      { to: "/inventario-reporte", icon: FileBarChart2, label: "Reporte inventario", module: "bodega" },
    ],
  },
  {
    key: "facturacion",
    label: "Facturación SRI",
    icon: ScrollText,
    items: [
      { to: "/facturacion", icon: Receipt, label: "Facturas SRI", module: "facturacion", submodule: "facturas", keywords: "electronica emision" },
      { to: "/facturacion/auditoria-secuencial", icon: Search, label: "Auditoría secuencial", module: "facturacion", keywords: "huecos saltados numeros gaps" },
      { to: "/sri-complementos", icon: FileMinus2, label: "Complementos SRI", module: "facturacion", keywords: "nota credito debito guia retencion" },
      { to: "/retenciones-recibidas", icon: ArrowDownCircle, label: "Retenciones recibidas", module: "contabilidad", submodule: "retenciones_recibidas" },
    ],
  },
  {
    key: "finanzas",
    label: "Finanzas",
    icon: Banknote,
    items: [
      { to: "/contabilidad", icon: Calculator, label: "Contabilidad · CxC/CxP", module: "contabilidad", keywords: "cartera cuentas cobrar pagar libros" },
      { to: "/cierres-inventario", icon: FileBarChart2, label: "Cierres de inventario", module: "contabilidad", keywords: "valor inventario fin de mes cierre mensual" },
      { to: "/contabilidad/pagos-unificado", icon: Banknote, label: "Pagos (Facturas+Gastos)", module: "contabilidad", keywords: "pagar egresos" },
      { to: "/documentos-electronicos", icon: FileCheck2, label: "Documentos SRI", module: "contabilidad", keywords: "registro comprobantes autorizados anulados" },
      { to: "/recordatorios-cobro", icon: Mail, label: "Recordatorios cobro", module: "contabilidad", submodule: "cxc" },
      { to: "/gastos-operativos", icon: Wallet, label: "Gastos operativos", module: "contabilidad", submodule: "gastos_operativos" },
      { to: "/config-contable", icon: Settings2, label: "Config. asientos auto.", module: "contabilidad", submodule: "config" },
      // ITER197 (Feb 2026): acceso a devoluciones/descuentos de comisiones desde Contabilidad
      { to: "/comisiones?tab=aj", icon: Percent, label: "Descuentos por devoluciones", module: "contabilidad", keywords: "notas credito devoluciones vendedores comisiones" },
    ],
  },
  {
    key: "maestros",
    label: "Maestros",
    icon: Database,
    items: [
      { to: "/sucursales", icon: Building2, label: "Sucursales", module: "maestros", submodule: "sucursales" },
      { to: "/catalogos", icon: BookMarked, label: "Catálogos", module: "maestros", submodule: "catalogo" },
      { to: "/productos", icon: Pill, label: "Productos", module: "maestros", submodule: "productos", keywords: "medicamentos" },
      { to: "/vademecum", icon: BookOpen, label: "Vademécum", module: "maestros", submodule: "vademecum" },
      { to: "/clientes", icon: UserCheck, label: "Clientes", module: "maestros", submodule: "clientes" },
      { to: "/proveedores", icon: Truck, label: "Proveedores", module: "maestros", submodule: "proveedores" },
      { to: "/importaciones", icon: FileSpreadsheet, label: "Importación Excel", module: "maestros", submodule: "importaciones" },
    ],
  },
  {
    key: "personas",
    label: "Personas",
    icon: UsersRound,
    items: [
      { to: "/rrhh", icon: UsersRound, label: "Recursos humanos", module: "rrhh", keywords: "empleados nomina" },
      { to: "/comisiones", icon: Percent, label: "Comisiones", module: "rrhh" },
    ],
  },
  {
    key: "admin",
    label: "Administración",
    icon: Cog,
    items: [
      { to: "/gerencia", icon: LineChart, label: "Dashboard gerencia", module: "gerencia", keywords: "kpi indicadores" },
      { to: "/salud-financiera", icon: Activity, label: "Salud financiera", module: "gerencia" },
      { to: "/cumplimiento", icon: ShieldCheck, label: "Cumplimiento tributario", module: "gerencia", keywords: "sri resoluciones normativa vigilancia ficha tecnica retenciones iva parametros" },
      { to: "/reportes", icon: FileBarChart2, label: "Reportes", module: "gerencia", keywords: "ventas cliente comisiones" },
      { to: "/regulatorio", icon: AlertCircle, label: "Regulatorio", module: "regulatorio" },
      { to: "/auditoria", icon: FileClock, label: "Auditoría y rotación", module: "seguridad", keywords: "logs bitacora" },
      { to: "/usuarios", icon: UsersIcon, label: "Usuarios", module: "seguridad" },
      { to: "/config-empresa", icon: Building2, label: "Empresa y logo", module: "seguridad" },
      { to: "/admin/migracion", icon: Database, label: "Migración de datos", role: "admin" },
      { to: "/admin/correos", icon: Mail, label: "Correos automáticos", role: "admin", keywords: "smtp email" },
      { to: "/admin/respaldos-sri", icon: Archive, label: "Respaldos SRI", role: "admin" },
      { to: "/admin/tipos-retencion", icon: Percent, label: "Catálogo retenciones SRI", role: "admin" },
      { to: "/admin/secuenciales", icon: Hash, label: "Secuenciales SRI", role: "admin" },
    ],
  },
];

export { Briefcase as DefaultNavIcon, Boxes };

/**
 * Filtra grupos e items respetando permisos (module/submodule/role).
 * `permCtx` = { role, hasModule(mod), hasSubmodule(mod, sub) }
 */
export function filterGroupsByPermissions(groups, permCtx) {
  const { role, hasModule, hasSubmodule } = permCtx;
  const out = [];
  for (const g of groups) {
    const items = g.items.filter((it) => {
      if (it.role && role !== it.role) return false;
      if (!it.module) return true;
      if (!hasModule(it.module)) return false;
      if (it.submodule) return hasSubmodule(it.module, it.submodule);
      return true;
    });
    if (items.length > 0) out.push({ ...g, items });
  }
  return out;
}

/** Normaliza texto (acentos, minúsculas) para búsqueda. */
export function normalize(s) {
  return (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
